export default function () {
	let debounceTimer;
	let grayFloatLine = document.getElementById('gray-float-line');
	let grayFloatLineRefBottom = document.getElementById('gray-float-line-ref-bottom');
	let isSticky = false;

	if (!grayFloatLine) {
		return false;
	}

	const updateNotificationPosition = function (isBottom) {
		const notifications = document.getElementsByClassName('notification');
		if (notifications.length > 0) {
			for (const notification of notifications) {
				if (isBottom) {
					notification.classList.add('sticky-bottom');
				} else {
					notification.classList.remove('sticky-bottom');
				}
			}
		}
	}

	// Funkce pro zjištění, zda je pruh v HTML
	function updateStickyState() {
		let rectBottom = grayFloatLineRefBottom ? grayFloatLineRefBottom.getBoundingClientRect() : {top: -Infinity}; // dolní referenční prvek
		let windowHeight = Math.round(window.innerHeight);
		let rectBottomTop = rectBottom.top;

		if (rectBottomTop <= windowHeight && isSticky) {
			grayFloatLine.classList.remove('sticky');
			updateNotificationPosition(true);
		} else if (rectBottomTop >= windowHeight && !isSticky) {
			grayFloatLine.classList.add('sticky');
			updateNotificationPosition(false);
		}
	}

	// Scroll event
	window.addEventListener('scroll', function () {
		// Vyčistíme předchozí debouncing
		clearTimeout(debounceTimer);
		isSticky = grayFloatLine.classList.contains("sticky");
		// Zpoždění debouncingu
		debounceTimer = setTimeout(function () {
			updateStickyState(isSticky);
		}, 50);
	});

	// Vyhodnocení při načtení stránky a při vložení zpět do DOM
	window.addEventListener('load', updateStickyState);
	window.addEventListener('DOMContentLoaded', updateStickyState);

	// Použití MutationObserver k detekci změn v DOM
	const observer = new MutationObserver((mutationsList) => {
		for (const mutation of mutationsList) {
			if (mutation.type === 'childList') {
				// Pokud byl přidán nebo změněn prvek `gray-float-line`
				if ([...mutation.addedNodes].some(node => node.id === 'gray-float-line')) {
					grayFloatLine = document.getElementById('gray-float-line'); // Aktualizace odkazu
					updateStickyState();
				}
			}
		}
	});

	// Inicializace observeru
	observer.observe(document.body, {
		childList: true, // Sledování přidání nebo odebrání prvků
		subtree: true    // Sledování změn v celém DOM
	});
}
